/* Progressive room tabs; each panel remains readable without JavaScript. */
if (!customElements.get('kr-size-rooms')) {
  customElements.define('kr-size-rooms', class extends HTMLElement {
    connectedCallback() {
      if (this.abort && !this.abort.signal.aborted) return;
      this.abort = new AbortController();
      this.tabs = [...this.querySelectorAll('[data-room-tab]')];
      this.panels = [...this.querySelectorAll('[data-room-panel]')];
      if (!this.tabs.length) return;
      this.querySelector('[data-room-tabs]').hidden = this.tabs.length < 2;
      this.select(0);
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.select(index), {signal:this.abort.signal});
        tab.addEventListener('keydown', event => {
          let next = index;
          if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
          else if (event.key === 'ArrowLeft') next = (index + this.tabs.length - 1) % this.tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = this.tabs.length - 1;
          else return;
          event.preventDefault(); this.select(next); this.tabs[next].focus();
        }, {signal:this.abort.signal});
      });
      this.addEventListener('shopify:block:select', event => {
        const index = this.panels.findIndex(panel => panel.dataset.blockId === event.detail?.blockId);
        if (index >= 0) this.select(index);
      }, {signal:this.abort.signal});
    }
    select(index) {
      this.tabs.forEach((tab, i) => { tab.setAttribute('aria-selected', String(i === index)); tab.tabIndex = i === index ? 0 : -1; });
      this.panels.forEach((panel, i) => { panel.hidden = i !== index; });
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}
